<template>
    <div class="animated fadeIn">
      <b-form @submit.stop.prevent="onSubmit">

        <b-card class="card-accent-info" header="Transações">
            <b-card-body>

                <b-row>
                    <b-col cols="auto" class="mr-auto">
                        
                    <!--
                        <b-form-group>
                            <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                            &nbsp;
                            <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                            &nbsp;
                            <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
                        </b-form-group>
                    -->
                    </b-col>
                    <b-col cols="auto" class="">
                    <b-form-group>
                        <b-button variant="github" class="mr-1 btn-brand" @click="manualInsert()"><i class="fa fa-plus"></i><span>Inserção Manual</span></b-button>
                    </b-form-group>
                    </b-col>
                </b-row>
                    

                <b-row>
                    <b-col cols="auto">
                    <b-form-group>
                        <label for="plaza" style="font-size: 0.8em">Praça</label>
                        <b-form-select id="plaza"
                            v-model="filters.plaza"
                            :plain="true"
                            :options="plazaDDL"
                            :value="[null,'c']">
                        </b-form-select>
                    </b-form-group>
                    </b-col>

                    <b-col cols="auto">
                    <b-form-group>
                        <label for="lane" style="font-size: 0.8em">Pista</label>
                        <b-form-select id="lane"
                            v-model="filters.lane"
                            :plain="true"
                            :options="laneDDL"
                            :value="[null,'c']">
                        </b-form-select>
                    </b-form-group>
                    </b-col>
        
                    <b-col cols="auto">
                    <b-form-group>
                        <label for="name" style="font-size: 0.8em">Filtro</label>
                        <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
                    </b-form-group>
                    </b-col>
            
                    <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                    <b-form-group>
                        <p></p>
                        <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
                    </b-form-group>
                    </b-col>
        
                    <b-col cols="auto" class="">
                    <b-form-group >
                        <label for="perPage">Linhas</label>
                        <b-form-select v-model="table.perPage" id="perPage"
                            :plain="true"
                            :options="[5,10,20,50]">
                        </b-form-select>
                        </b-form-group>
                    </b-col>
                    
                </b-row>

                <b-table
                    :items="filteredItems"
                    :fields="table.fields"
                    :select-mode="table.selectMode"
                    responsive="sm"
                    ref="selectableTable"
                    selectable
                    :primary-key="table.primaryKey"
                    :tbody-transition-props="table.transProps"
                    sort-icon-left
                    @row-selected="onRowSelected"
                    :per-page="table.perPage"
                    :current-page="table.currentPage"
                    :busy="table.isBusy"
                    hover
                    striped>

                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                    
                </b-table>
            </b-card-body>
        </b-card>

      </b-form>

      <b-modal
              v-model="manualInsertModal"
              id="manual-insert-modal"
              centered
              hide-footer
              title="Inserção Manual"
              size="lg">
  
        <b-nav fill>
            <b-nav-item :active="tabInfo=='C'" @click="tabInfo='C'">Transação</b-nav-item>
        </b-nav>

        <b-card v-show="tabInfo=='C'">
            <transaction-manual-insert-component></transaction-manual-insert-component>
        </b-card>
      </b-modal>

    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  import TransactionComponent from './TransactionComponent.vue'
  import TransactionManualInsertComponent from './TransactionManualInsertComponent.vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
      return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
      success: toast,
      error: toast,
      info: toast,
      warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
  
    export default {
      name: 'Transaction',
      computed: {
        selectedItem() {
            return this.item
        },
        totalRows: function () { return this.getRowCount() },
        filteredItems() {
            try {
                return this.items.filter(item => {
                    return (this.filters.key == '' || (
                        this.$utils.filterString(item.name, this.filters.key)
                        || (this.filters.key == item.code)
                        //|| this.$utils.filterString(item.departmentName, this.filters.key)
                        //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                        //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                        //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                        ))
                        //&& (this.filters.departmentId == 0 || (this.filters.departmentId == item.departmentId))
                        //&& (this.filters.typeId == 0 || (this.filters.typeId == item.typeId))
                        //&& (this.filters.statusId == 0 || (this.filters.statusId == item.statusId ))
                        //&& (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )
                        
                                    
                })
            }
            catch(e) {
                return this.items;
            }
        }
      },
      components: {
        TransactionComponent,
        TransactionManualInsertComponent
      },
      data: () => {
          return {
            tabInfo: 'C',
            manualInsertModal: false,
            items: [],
            plazaDDL: [],
            laneDDL: [],
            filters: {
                plaza: 0,
                lane: 0
            },
            table: {
                fields: [
                    //{key: 'show_details', label: "", thStyle: { width: "40px" } },
                    {key: 'idtransaction', label: 'Transação', sortable: true, class: 'text-center' },
                    //{key: 'costcenter', label: 'Centro de Custo', sortable: true },
                    {key: 'plaza', label: 'Praça', sortable: true },
                    {key: 'lane', label: 'Pista', sortable: true },
                    {key: 'seqtrans', label: 'Sequencial', sortable: true },
                    {key: 'plate', label: 'Placa', sortable: true },
                    //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
                    //{key: 'totalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
                    //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
                    //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
                    //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
                    //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
                ],
                modes: ['multi', 'single', 'range'],
                selectMode: 'multi',
                primaryKey: 'id',
                isBusy: false,
                currentPage: 1,
                totalRows: 0,
                perPage: 10,
                transProps: {
                    name: 'flip-list'
                }
            }
          }
      },
      methods: {
        onRowSelected() {

        },
        manualInsert() {
            this.manualInsertModal = true
        },
        async refreshData() {
            var s = this
            var currentUser = this.$store.state.currentUser
            this.isBusy = true

            await axios.get(
                this.$store.state.ws_url + "/transaction?plaza=" + s.filters.plaza + "&lane=" + s.filters.lane + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.items = resp.data.obj;
            }
            ).catch(function (error) {
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Erro',
                    message: 'Sem permissão de acesso. Verifique e tente novamente.',
                    timeout: 3000
                })
            })

            this.isBusy = false;
        }
      }
      ,mounted: function() {
        this.refreshData()
      }
    }
  
  </script>